import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

import * as paper from 'paper';

import {ApplicationProvider} from '../application/application'



 let path: any; //* Der Pfad der gezeichnet wird
 let drag = false; //* Wenn drag aufgehoben wird = false
 let papercanvas: HTMLCanvasElement; //* Das Canvaselement auf das gezeichnet wird
 let inputtype: string = 'touch'; //*mouse oder touch Eingabe


@Injectable()
export class PaintoncanvasProvider {

 

  constructor(public http: Http, public myapp: ApplicationProvider) {
    console.log('Hello PaintoncanvasProvider Provider');
  }


  /**
   * Hier wird das Canvas per id gesucht und für das zeichen durch paper.js vorbereitet
   * 
   * @param {string} canvasId Die Id des Canvaselements
   * @memberof PaintoncanvasProvider
   */
  public initPaper(canvasId: string) {
    papercanvas = <HTMLCanvasElement>document.getElementById(canvasId);

    paper.setup(papercanvas);
    console.log("initPaper sucess");

    this.addEvents();
  }


  /**
   * Je nach Inputtype werden die entsprechenden Events verbunden
   * 
   * @memberof PaintoncanvasProvider
   */
  addEvents() {

    switch (inputtype) {
      case 'mouse':
        papercanvas.addEventListener('mousedown', this.mousedownEvent);
        papercanvas.addEventListener('mousemove', this.mousedragEvent);
        papercanvas.addEventListener('mouseup', this.mouseupEvent);
        papercanvas.addEventListener('mouseout', this.mouseoutEvent);
        break;
      case 'touch':
        papercanvas.addEventListener('touchstart', this.touchstartEvent);
        papercanvas.addEventListener('touchmove', this.touchmoveEvent);
        papercanvas.addEventListener('touchend', this.touchendEvent);
        break;
      default:
        throw 'Inputtype nicht bekannt'
    }

  }




  /**
   * Behandelt mousedown event
   * Hier wird Style der Linie zugewiesen, der neue Pfad erstellt unbd der erste Punkt gesetzt
   * @param {any} event 
   * @memberof PaintoncanvasProvider
   */
  mousedownEvent(event) {

    //Set  flag to detect mouse drag
    drag = true;
    path = new paper.Path();
    // path.strokeColor = 'black';
    path.style = {
      //fillColor: 'blue',
      strokeColor: 'red',
      strokeWidth: 10,
      strokecap: 'round'
    };
    path.add(new paper.Point(event.layerX, event.layerY));

    console.log("downevent sucess:" + "layerX" + event.layerX + "layerY" + event.layerY)
  }




  /**
   * Behandelt wenn mousemove event
   * Hier wird der Pfad gezeichnet
   * @param {any} event 
   * @memberof PaintoncanvasProvider
   */
  mousedragEvent(event) {

    if (drag) {
      path.add(new paper.Point(event.layerX, event.layerY));
      path.smooth();
    }
    console.log("dragevent sucess:" + "layerX" + event.layerX + "layerY" + event.layerY);
  }



  /**
   * Behandelt mouseup event
   * Drag wird auf false gestetztt, dadurch wird nicht weiter gezeichnet
   * @param {any} event 
   * @memberof PaintoncanvasProvider
   */
  mouseupEvent(event) {

    //Clear Mouse Drag Flag
    drag = false;


    console.log("Upevent sucess:" + "layerX" + event.layerX + "layerY" + event.layerY);

  }


  /**
   * Behandelt mouseout Event 
   * Wenn die Maus das Canvas verlässt wird zeichen abgebrochen
   * @param {any} event$ 
   * @memberof PaintoncanvasProvider
   */
  mouseoutEvent(event$) {
    console.log("mouse out of element")
    drag = false;
  }


  //Beginn: Das funktioniert mit dem Finger

  //wenn touchstart, dann
  touchstartEvent(event: TouchEvent) {
   
    console.log("touchstartEvent")
    //Set  flag to detect  drag
    drag = true;
    path = new paper.Path();
    // path.strokeColor = 'black';
    path.style = {
      //fillColor: 'blue',
      strokeColor: 'red',
      strokeWidth: 10,
      strokecap: 'round'
    };

    
    var b = papercanvas.getBoundingClientRect();
var x: number;
    x = event.changedTouches[0].pageX - b.left;

var y: number;
    // var b = papercanvas.getBoundingClientRect();

    y = event.changedTouches[0].pageY - b.top;


path.add(new paper.Point(x, y));

console.log("touchmoveEvent:" + "pageX" + event.changedTouches[0].pageX + "getXCoordinate " + x + "; pageY" + event.changedTouches[0].pageY + "getYCoordinate " +y);

  }

  //wenn touchmove bewegt wird
  touchmoveEvent(event: TouchEvent) {
    console.log("touchmoveEvent");


    var b = papercanvas.getBoundingClientRect();
var x: number;
    x = event.changedTouches[0].pageX - b.left;

var y: number;
    // var b = papercanvas.getBoundingClientRect();

    y = event.changedTouches[0].pageY - b.top;


if (drag) {
                    path.add(new paper.Point(x, y));
                    path.smooth();
                }

console.log("touchmoveEvent:" + "pageX" + event.changedTouches[0].pageX + "getXCoordinate " + x + "; pageY" + event.changedTouches[0].pageY + "getYCoordinate " +y);
    
  }

  //wenn touchend, dann
  touchendEvent(event: TouchEvent) {
    console.log("touchendEvent");
    //Clear Mouse Drag Flag
    drag = false;

console.log("touchendEvent: " + "pageX: " + event.changedTouches[0].pageX  + "; pageY" + event.changedTouches[0].pageY );
  }

  //! todo Das geht noch nicht
  focusoutEvent(event) {
    console.log("focusoutEvent")
    document.getElementById('message').innerHTML = "focusoutEvent";
    drag = false;
  }

  //Ende Das funktioniert mit dem Finger



  //alles, bis auf view, löschen
  clearPapercanvas(event) {
    paper.project.activeLayer.removeChildren();
    //neu zeichnen
    paper.view.draw();
  }
  // Ende Haupteil PaperJs 

// // Das berechnet die x Koordinate, da touch kein layerY kennt
//   private getXCoordinate(pagex: number): number {
//     var x: number;
//     var b = papercanvas.getBoundingClientRect();

//     x = pagex - b.left;
//     console.log("pagex: " + pagex + "; b.left: " + b.left + "; x: " + x);
//     return x;
//   }

//   // Das berechnet die y Koordinate, da touch kein layerY kennt
//   private getYCoordinate(pagey: number) {
//     var y: number;
//     var b = papercanvas.getBoundingClientRect();

//     y = pagey - b.top;
//     console.log("pagey: " + pagey + "; b.top: " + b.top + "; y: " + y);
//     return y;
//   }



}



// WEBPACK FOOTER //
// ./src/providers/paintoncanvas/paintoncanvas.ts